import PropTypes from 'prop-types';
import noop from "ramda-extension/es/noop";
import React from 'react';
import { addMinutes, cloneDate, formatDate, getHour, getMinute, getStartOfDay, isTimeDisabled, isTimeInDisabledRange, newDate } from '../date_utils';
export default class Time extends React.Component {
    static get defaultProps() {
        return {
            intervals: 30,
            onTimeChange: noop,
            todayButton: null,
            timeCaption: 'Time'
        };
    }
    componentDidMount() {
        // code to ensure selected time will always be in focus within time window when it first appears
        const multiplier = 60 / this.props.intervals;
        const currH = this.props.selected ? getHour(this.props.selected) : getHour(newDate());
        this.list.scrollTop = 30 * (multiplier * currH);
    }
    handleClick = (time)=>{
        if ((this.props.minTime || this.props.maxTime) && isTimeInDisabledRange(time, this.props) || this.props.excludeTimes && isTimeDisabled(time, this.props.excludeTimes) || this.props.includeTimes && !isTimeDisabled(time, this.props.includeTimes)) {
            return;
        }
        this.props.onChange(time);
    };
    liClasses = (time, currH, currM)=>{
        const classes = [
            'react-datepicker__time-list-item'
        ];
        if (currH === getHour(time) && currM === getMinute(time)) {
            classes.push('react-datepicker__time-list-item--selected');
        }
        if ((this.props.minTime || this.props.maxTime) && isTimeInDisabledRange(time, this.props) || this.props.excludeTimes && isTimeDisabled(time, this.props.excludeTimes) || this.props.includeTimes && !isTimeDisabled(time, this.props.includeTimes)) {
            classes.push('react-datepicker__time-list-item--disabled');
        }
        return classes.join(' ');
    };
    renderTimes = ()=>{
        const times = [];
        const format = this.props.format ? this.props.format : 'hh:mm A';
        const intervals = this.props.intervals;
        const activeTime = this.props.selected ? this.props.selected : newDate();
        const currH = getHour(activeTime);
        const currM = getMinute(activeTime);
        const base = getStartOfDay(newDate());
        const multiplier = 1440 / intervals;
        for(let i = 0; i < multiplier; i++){
            times.push(addMinutes(cloneDate(base), i * intervals));
        }
        return times.map((time, i)=>/*#__PURE__*/ React.createElement("li", {
                key: i,
                onClick: this.handleClick.bind(this, time),
                className: this.liClasses(time, currH, currM)
            }, formatDate(time, format)));
    };
    render() {
        let height = null;
        if (this.props.monthRef) {
            height = this.props.monthRef.clientHeight - 39;
        }
        return /*#__PURE__*/ React.createElement("div", {
            className: `react-datepicker__time-container ${this.props.todayButton ? 'react-datepicker__time-container--with-today-button' : ''}`
        }, /*#__PURE__*/ React.createElement("div", {
            className: "react-datepicker__header react-datepicker__header--time"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "react-datepicker-time__header"
        }, this.props.timeCaption)), /*#__PURE__*/ React.createElement("div", {
            className: "react-datepicker__time"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "react-datepicker__time-box"
        }, /*#__PURE__*/ React.createElement("ul", {
            className: "react-datepicker__time-list",
            ref: (list)=>{
                this.list = list;
            },
            style: height ? {
                height
            } : {}
        }, this.renderTimes.bind(this)()))));
    }
}
Time.propTypes = {
    excludeTimes: PropTypes.array,
    format: PropTypes.string,
    includeTimes: PropTypes.array,
    intervals: PropTypes.number,
    maxTime: PropTypes.object,
    minTime: PropTypes.object,
    monthRef: PropTypes.object,
    onChange: PropTypes.func,
    selected: PropTypes.object,
    timeCaption: PropTypes.string,
    todayButton: PropTypes.string
};
